import React from 'react';
import { motion } from 'framer-motion';
export function PricingPlans() {
  return <section className="w-full py-12 px-4 bg-base" id="pricing" data-id="element-167">
      <div className="max-w-6xl mx-auto" data-id="element-168">
        <div className="text-center mb-16" data-id="element-169">
          <h2 className="text-4xl md:text-5xl font-extrabold text-text-main" data-id="element-170">
            ELEGÍ TU KIT PACK
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-171">
          {/* Plan A */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-alt border border-primary/20 rounded-3xl p-8 md:p-10 flex flex-col h-full" data-id="element-172">
            <div className="text-4xl mb-4" data-id="element-173">📘</div>
            <h3 className="text-2xl font-bold text-text-main mb-2" data-id="element-174">
              KIT PACK CREÁ REELS Y FACTURÁ DESDE 0
            </h3>
            <p className="text-primary font-semibold mb-6" data-id="element-175">6 Tomos + 6 Bonos</p>

            <div className="bg-base rounded-xl p-4 mb-8 border border-alt" data-id="element-176">
              <p className="text-sm text-text-muted mb-1" data-id="element-177">Ideal para:</p>
              <p className="font-medium text-text-main" data-id="element-178">
                Todo el año de contenido resuelto
              </p>
            </div>

            <div className="mt-auto mb-8" data-id="element-179">
              <p className="text-text-muted line-through text-xl mb-1" data-id="element-180">
                $89.000
              </p>
              <div className="flex items-baseline gap-2" data-id="element-181">
                <span className="text-5xl font-extrabold text-text-main" data-id="element-182">
                  $19.990
                </span>
                <span className="text-xl font-bold text-text-muted" data-id="element-183">ARS</span>
              </div>
            </div>

            <a id="plan-19990" href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNC7mdrcAxviHhOjvhF6VIA/es-ar?_r=AQABNiY6VVJWoEGLehotUaLJRhE3vrUooz0X390AtzyR1DE&cart_link_id=ojNS98B4&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="block text-center w-full py-4 rounded-xl bg-cta/10 text-cta border border-cta/30 font-bold text-lg hover:bg-cta hover:text-base transition-colors duration-300 scroll-mt-24" data-id="element-184">
              → QUIERO MI KIT PACK
            </a>
          </motion.div>

          {/* Plan B - Featured */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-alt border-2 border-primary rounded-3xl p-8 md:p-10 flex flex-col h-full relative shadow-[0_0_30px_rgba(123,63,242,0.2)] transform md:-translate-y-4" data-id="element-185">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-text-main text-xs font-bold px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-186">
              MÁS POPULAR
            </div>

            <div className="text-4xl mb-4" data-id="element-187">🏆</div>
            <h3 className="text-2xl font-bold text-text-main mb-2" data-id="element-188">
              KIT PACK + NEGOCIO EN AUTOMÁTICO ⭐
            </h3>
            <p className="text-primary font-semibold mb-6" data-id="element-189">
              6 Tomos + 6 Bonos + Sistema de Automatización y Escalamiento
            </p>

            <div className="bg-base rounded-xl p-4 mb-8 border border-primary/20" data-id="element-190">
              <p className="text-sm text-text-muted mb-1" data-id="element-191">Ideal para:</p>
              <p className="font-medium text-text-main" data-id="element-192">
                Emprendedores que quieren ganar más trabajando menos
              </p>
            </div>

            <div className="mt-auto mb-8" data-id="element-193">
              <p className="text-text-muted line-through text-xl mb-1" data-id="element-194">
                $119.000
              </p>
              <div className="flex items-baseline gap-2" data-id="element-195">
                <span className="text-5xl font-extrabold text-text-main" data-id="element-196">
                  $27.990
                </span>
                <span className="text-xl font-bold text-text-muted" data-id="element-197">ARS</span>
              </div>
            </div>

            <a id="plan-27990" href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNC7mtjQnw4bIYc6Z4wbxtC/es-ar?_r=AQABAq3faZLqRgNe-Ll5TPWrDIp-W5u9n5uuDJOdghzSZt8&cart_link_id=nD9IkIWz&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="btn-glow block text-center w-full py-5 rounded-xl bg-cta text-base font-bold text-lg uppercase tracking-wide hover:scale-[1.02] transition-transform duration-300 scroll-mt-24" data-id="element-198">
              → QUIERO EL KIT PACK + NEGOCIO EN AUTOMÁTICO
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}